/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "./src/styles/css/style-react.css"
import "./src/styles/css/nucleo-icons-page-styles.css"
import "./src/lib/magnific-popup/magnific-popup.css"

import WebFont from 'webfontloader';

WebFont.load({
    google: {
        families: ['Material Icons', 'Open Sans:300,400,700', 'Nucleo', 'Jost:300,400,600,700', 'Oswald:300,600,700', 'Gilroy: 300, 400, 700', 'sans-serif']
    }
});